import React, { useMemo, useState } from 'react'
import { IWorkspace } from '../../services/api'
import { Autocomplete, AutocompleteOption } from '../Autocomplete'

interface WorkspaceOption extends AutocompleteOption {
  workspace: IWorkspace
}

interface WorkspaceAutocompleteProps {
  workspaces: IWorkspace[]
  value?: IWorkspace
  onChange: (workspace: IWorkspace | undefined) => void
  disabled?: boolean
  placeholder?: string
}

export const WorkspaceAutocomplete: React.FC<WorkspaceAutocompleteProps> = ({
  workspaces,
  value,
  onChange,
  disabled = false,
  placeholder = 'Workspace...',
}) => {
  const [query, setQuery] = useState('')

  const mappedOptions: WorkspaceOption[] = useMemo(() => {
    const q = query.toLowerCase()
    return workspaces
      .filter((w) => {
        const name = (w.name || w.slug || '').toLowerCase()
        return !q || name.includes(q)
      })
      .map((w) => ({
        id: w.id,
        label: w.name || w.slug,
        dotColor: w.color,
        workspace: w,
      }))
  }, [workspaces, query])

  const mappedValue: WorkspaceOption | undefined = value
    ? { id: value.id, label: value.name || value.slug, dotColor: value.color, workspace: value }
    : undefined

  return (
    <Autocomplete<WorkspaceOption>
      options={mappedOptions}
      value={mappedValue}
      onChange={(opt) => onChange(opt?.workspace)}
      onQueryChange={setQuery}
      disabled={disabled}
      placeholder={placeholder}
      emptyMessage="Brak workspaces"
      tintColor={value?.color}
      iconPadding="pl-6"
      icon={
        <svg className="h-2 w-2" viewBox="0 0 8 8" aria-hidden="true">
          <circle cx={4} cy={4} r={4} fill={value?.color || '#9ca3af'} />
        </svg>
      }
    />
  )
}
